import { fetchSites } from 'api/site';
import { useQuery } from 'react-query';
import { washHub } from 'store/slices';

export const useSites = (fetchAll?: boolean) => {
  const washHubId = fetchAll
    ? undefined
    : washHub.selectors.useSelectedWashHubId();

  const queryKey = fetchAll
    ? 'fetch-sites-active-select-all'
    : `fetch-sites-active-${washHubId}-select`;
  const queryFn = () => fetchSites(washHubId, 1);

  const query = useQuery(queryKey, queryFn);

  return query;
};
